import { ArticleHeading2, ArticleParagraph2, LinkButton, UIHeading2 } from '@cian/ui-kit';
import { Section } from '../Section';
import * as React from 'react';
import * as styles from './Mortgage.css';
import { IMortgageProps } from './types';
import { ContentContainer } from '../ContentContainer';
import { MORTGAGE_LINK } from '../../constants/mortgage';
import { numberToPrettyString } from '@cian/utils';

interface IMortgageMobileProps extends IMortgageProps {
  minRate: number;
  minPayment: number;
  onMortgageButtonClick(): void;
}

export const MortgageMobile: React.FC<IMortgageMobileProps> = ({
  fields,
  minRate,
  minPayment,
  programs,
  onMortgageButtonClick,
}) => {
  return (
    <Section dataName="MortgageSection">
      <div className={styles['inner']}>
        <ContentContainer>
          <div className={styles['title']}>
            <UIHeading2>Построить в ипотеку</UIHeading2>
          </div>
          {fields}
          <div className={styles['values']}>
            <div className={styles['row']}>
              {['Ставка', 'Платеж в месяц'].map(header => (
                <ArticleParagraph2 color="gray60_100" key={header}>
                  {header}
                </ArticleParagraph2>
              ))}
            </div>
            <div className={styles['row']}>
              <ArticleHeading2>от {minRate}%</ArticleHeading2>
              <ArticleHeading2>от {numberToPrettyString(minPayment)} ₽</ArticleHeading2>
            </div>
          </div>
        </ContentContainer>
        {programs}
        <ContentContainer>
          <div className={styles['text']}>
            <ArticleParagraph2 color="gray60_100">
              Мы подаем анкету в несколько банков и предлагаем лучшие условия
            </ArticleParagraph2>
          </div>
          <LinkButton theme="fill_secondary" fullWidth href={MORTGAGE_LINK} onClick={onMortgageButtonClick}>
            Заполнить анкету
          </LinkButton>
        </ContentContainer>
      </div>
    </Section>
  );
};
